import { setUserDataAction, setCompanyDataAction, updateUserPhoneAction } from "../actions/userAction";
import { SESSION_DATA_READY } from "../actions/authSessionAction";

const initialState = {
  company: null,
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case updateUserPhoneAction:
      return state.id === action.payload.userId ? { ...state, phoneNumber: action.payload.phoneNumber } : state;
    case SESSION_DATA_READY:
      return { ...action.payload.user, company: action.payload.company };
    case setUserDataAction:
      return {
        ...action.payload,
        company:
          state.id === action.payload.id && state.companyId === action.payload.companyId
            ? state.company
            : null,
      };
    case setCompanyDataAction:
      return {
        ...state,
        company: action.payload,
      };
    default:
      return state;
  }
};
